import { z } from 'zod';

export const UpsertHlSecurityMappingSchema = z.object({
  sourceDescription: z.string().trim().min(1).max(240),
  symbol: z
    .string()
    .trim()
    .min(1)
    .max(16)
    .regex(/^[A-Z0-9.-]+$/i, 'Symbol must contain letters, digits, dots, or hyphens.')
    .transform((value) => value.toUpperCase()),
});

export type UpsertHlSecurityMappingInput = z.infer<typeof UpsertHlSecurityMappingSchema>;
